import ClientDto from '../client/client-dto';
import DomainDto from './domain-dto';

export default class ServiceDto
{
    public id: number|null = null;
    public client: ClientDto|null = null;
    public domain: DomainDto|null = null;
    public stage = '';
    public title = '';
    public invoiceAmount = '0.00';
    public disabled = false;
    public dateExpiry: string|null = null;
    public dateUpdated = '';
}